import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { Header } from '../header/header';
import { Sidebar } from '../sidebar/sidebar';
import { AuthService, SpinnerLoadingService } from '@ribera-web/auth-data-access';
import { RestaurantLoaderUi } from '../restaurant-loader-ui/restaurant-loader-ui';

@Component({
  selector: 'lib-shell',
  standalone: true,
  imports: [CommonModule,
    Sidebar, Header, RouterOutlet, RestaurantLoaderUi],
  templateUrl: './shell.html',
  styleUrl: './shell.scss',
})
export class Shell {

    activeNav = signal('dashboard');
    isSidebarOpen = signal(false);

    authService = inject(AuthService);
    spinner = inject(SpinnerLoadingService);

    constructor(
        private router: Router
    ) {}

    onNavClick(id: string): void {
        this.activeNav.set(id);
        if (id === 'ventas') {
            this.router.navigate(['/ventas']);
        }
    }

    onLogout(): void {
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    toggleSidebar(): void {
        this.isSidebarOpen.update(v => !v);
    }

    onAperturaClick(): void {
        // Future: open apertura de caja modal
    }

}